export default function PillTitle(props) {
    return (
        <div className='flex justify-center'>
            <h1 className={`${props.className} px-10 py-2.5`}>
                {props.content}
            </h1>
        </div>
    )
}